// frontend/src/services/leadService.js

import api from './api';

class LeadService {
  async getLeads(filters = {}) {
    try {
      console.log('LeadService.getLeads called with:', filters);
      const response = await api.getLeads(filters);
      console.log('LeadService.getLeads response:', response);
      return response;
    } catch (error) {
      console.error('LeadService.getLeads error:', error);
      console.error('Error details:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      throw error.response?.data || { error: 'Failed to get leads' };
    }
  }

  async getLead(id) {
    try {
      const response = await api.getLead(id);
      return response;
    } catch (error) {
      console.error('LeadService.getLead error:', error);
      throw error.response?.data || { error: 'Failed to get lead' };
    }
  }

  async createLead(leadData) {
    try {
      const response = await api.createLead(leadData);
      return response;
    } catch (error) {
      console.error('LeadService.createLead error:', error);
      throw error.response?.data || { error: 'Failed to create lead' };
    }
  }

  async updateLead(id, leadData) {
    try {
      const response = await api.updateLead(id, leadData);
      return response;
    } catch (error) {
      console.error('LeadService.updateLead error:', error);
      throw error.response?.data || { error: 'Failed to update lead' };
    }
  }

  async deleteLead(id) {
    try {
      const response = await api.deleteLead(id);
      return response;
    } catch (error) {
      console.error('LeadService.deleteLead error:', error);
      throw error.response?.data || { error: 'Failed to delete lead' };
    }
  }

  async getStats() {
    try {
      const response = await api.getStats();
      return response;
    } catch (error) {
      console.error('LeadService.getStats error:', error);
      throw error.response?.data || { error: 'Failed to get stats' };
    }
  }

  async bookDemo(leadId, date, time) {
    try {
      const response = await api.bookDemo(leadId, date, time);
      return response;
    } catch (error) {
      console.error('LeadService.bookDemo error:', error);
      throw error.response?.data || { error: 'Failed to book demo' };
    }
  }

  async addActivity(activityData) {
    try {
      const response = await api.addActivity(activityData);
      return response;
    } catch (error) {
      console.error('LeadService.addActivity error:', error);
      throw error.response?.data || { error: 'Failed to add activity' };
    }
  }

  async getActivities(leadId) {
    try {
      const response = await api.getActivities(leadId);
      return response;
    } catch (error) {
      console.error('LeadService.getActivities error:', error);
      throw error.response?.data || { error: 'Failed to get activities' };
    }
  }
}

export default new LeadService();